import React from 'react';
import { HubSortListOrderEntry } from '../../hooks/useFetchHubSortList';

import './LineHaulScannerTable.scss';
import { Link } from 'react-router-dom';
import { setColorByStatus } from '../OrderScannerTable/OrderScannerTable';
import dayjs from 'dayjs';

interface Props {
  orders: HubSortListOrderEntry[];
}

function isPreSorted(order: HubSortListOrderEntry): boolean {
  return (
    order.presorted && order.partnerScanCount >= order.order.packagesNumber
  );
}

export default function LineHaulScannerTable({ orders }: Props) {
  return (
    <div className="u-pbl">
      <table className="linehaul-scanner-table">
        <thead>
          <tr>
            <th data-sort="id" data-sortmethod="number">
              Order ID
            </th>
            <th data-sort="id" data-sortmethod="number">
              Parcels
            </th>
            <th data-sort="id" data-sortmethod="number">
              Retailer
            </th>
            <th data-sort="id" data-sortmethod="number">
              Linehaul
            </th>
            <th data-sort="delivery_name" data-sortmethod="string">
              Sender
            </th>
            <th data-sort="presorted" data-sortmethod="boolean">
              Presorted?
            </th>
            <th data-sort="deliver_from" data-sortmethod="string">
              Delivery Day
            </th>
          </tr>
        </thead>
        <tbody>
          {orders.map(order => (
            <tr
              key={order.order.id}
              data-order-id={`'screen'${order.order.id}`}
            >
              <td
                style={{
                  borderLeftColor: setColorByStatus(
                    order.scannedParcelCount,
                    order.preciseParcelCount
                  ),
                }}
              >
                <Link to={`/orders/${order.order.id}`} className="link__clean">
                  {order.order.id}
                </Link>
              </td>
              <td> {`${order.order.packagesNumber}`}</td>
              <td
                style={{
                  color: order.partnerScansConfirmed ? '#0eb227' : '#dd4912',
                }}
              >
                {`${order.partnerScanCount}`}
              </td>
              <td>
                {' '}
                {`${order.scannedParcelCount}/${order.preciseParcelCount}`}
              </td>
              <td>{order.order.senderName}</td>
              <td>{isPreSorted(order) ? '\u2611' : '\u2610'}</td>
              <td>{dayjs(order.order.deliverFrom).format('DD.MM')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
